<form (ngSubmit)="submit()" [formGroup]="form" class="flex flex-col gap-4">
  <h3>Prorrogar plan</h3>

  <p class="cd-text-b3 text-neutral-600">
    Solo la fecha de finalización puede modificarse por prórroga.
  </p>

  <div class="rounded-lg bg-neutral-50 p-3 flex flex-col gap-1">
    <span class="cd-text-b4 text-neutral-500">Plan</span>
    <span class="cd-text-b2 text-neutral-800">{{ plan?.name || 'Plan activo' }}</span>
    <span class="cd-text-b4 text-neutral-500">Fin actual: {{ plan?.endDate ? (plan?.endDate | date:'dd/MM/yyyy') : '-' }}</span>
  </div>

  <div class="form-control">
    <label class="text-neutral-900" for="new-end-date">Nueva fecha de finalización</label>
    <core-datepicker formControlName="newEndDate" [compact]="true" placeholder="Seleccionar fecha"></core-datepicker>
  </div>

  @if (errorMessage) {
    <span class="cd-text-b4 text-error-600">{{ errorMessage }}</span>
  }

  <div class="w-full flex flex-row items-center gap-3">
    <button [disabled]="isSubmitting" class="btn btn-primary" type="submit">
      {{ isSubmitting ? 'Guardando...' : 'Guardar prórroga' }}
    </button>
    <button (click)="close()" [disabled]="isSubmitting" class="btn btn-primary-soft" type="button">
      Cancelar
    </button>
  </div>
</form>
